function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "url(#paint0_linear_20020771_68614)"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "white",
  strokeOpacity: 0.1
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25 14.5H17.5V7H14.5V14.5H7V17.5H14.5V25H17.5V17.5H25V14.5Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20020771_68614",
  x1: 0,
  y1: 16,
  x2: 32,
  y2: 16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7E6E56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.171875,
  stopColor: "#53442D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786458,
  stopColor: "#52422B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#775D37"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_20020771_68614",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(40.3 1.5) rotate(148.698) scale(31.9507 28.0176)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint1_radial_20020771_68614)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFDC60",
    style: {
      mixBlendMode: "overlay"
    }
  }), _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.aee3ff96d9b635064e4dcac859a023ec.svg";
export { ForwardRef as ReactComponent };